function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.1747 0.0545282C12.2603 0.113495 12.3116 0.211878 12.3116 0.317072V13.3961C12.3116 13.5225 12.2379 13.6368 12.1239 13.6871L0.435616 18.8394C0.339287 18.8819 0.228389 18.8722 0.140622 18.8136C0.0528546 18.7549 0 18.6553 0 18.5485V5.0731C0 4.94344 0.0775951 4.82686 0.19593 4.77871L11.8842 0.0226788C11.9802 -0.0163986 12.0891 -0.00446493 12.1747 0.0545282ZM0.623368 5.28775V18.0655L11.6883 13.188V0.785403L0.623368 5.28775Z",
  fill: "#737373"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.876 13.1052C11.9551 13.0704 12.0448 13.0704 12.1239 13.1052L23.8122 18.2576C23.9262 18.3079 23.9998 18.4221 23.9998 18.5485V20.9265C23.9998 21.0562 23.9224 21.1728 23.804 21.2209L12.1157 25.9771C12.0414 26.0072 11.9585 26.0072 11.8842 25.9771L0.19593 21.2209C0.0775951 21.1728 0 21.0562 0 20.9265V18.5485C0 18.4221 0.0737614 18.3079 0.187752 18.2576L11.876 13.1052ZM0.623368 18.7567V20.7119L12 25.3411L23.3764 20.7119V18.7567L12 13.7417L0.623368 18.7567Z",
  fill: "#737373"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.876 13.1052C11.9551 13.0704 12.0448 13.0704 12.1239 13.1052L23.8122 18.2576C23.9262 18.3079 23.9998 18.4221 23.9998 18.5485V19.3412C23.9998 19.4708 23.9224 19.5874 23.804 19.6356L12.1157 24.3916C12.0414 24.4218 11.9585 24.4218 11.8842 24.3916L0.19593 19.6356C0.0775951 19.5874 0 19.4708 0 19.3412V18.5485C0 18.4221 0.0737614 18.3079 0.187752 18.2576L11.876 13.1052ZM0.623368 18.7567V19.1265L12 23.7557L23.3764 19.1265V18.7567L12 13.7417L0.623368 18.7567Z",
  fill: "#737373"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.8252 0.0545282C11.9108 -0.00446493 12.0196 -0.0163986 12.1157 0.0226788L23.8039 4.77871C23.9223 4.82686 24 4.94344 24 5.0731V18.5485C24 18.6553 23.9471 18.7549 23.8591 18.8136C23.7715 18.8722 23.6606 18.8819 23.5642 18.8394L11.876 13.6871C11.762 13.6368 11.6882 13.5225 11.6882 13.3961V0.317072C11.6882 0.211878 11.7396 0.113495 11.8252 0.0545282ZM12.3116 0.785403V13.188L23.3766 18.0655V5.28775L12.3116 0.785403Z",
  fill: "#737373"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.9402 7.1895C15.0248 7.13035 15.1326 7.11743 15.2285 7.15492L20.2934 9.13658C20.4138 9.1837 20.4932 9.30134 20.4932 9.43254V16.8572C20.4932 16.9644 20.44 17.0643 20.3517 17.1228C20.2635 17.1814 20.1521 17.1906 20.0557 17.1473L14.9908 14.875C14.8778 14.8243 14.8049 14.7105 14.8049 14.5849V7.45085C14.8049 7.34638 14.8555 7.24862 14.9402 7.1895ZM15.4283 7.91252V14.3782L19.8698 16.3708V9.65028L15.4283 7.91252Z",
  fill: "#737373"
});

var SvgMyRooms = function SvgMyRooms(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMyRooms, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/my-rooms.1d746468.svg";
export { ForwardRef as ReactComponent };